
import React, { useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { UserRole } from '../../types';

const Header: React.FC = () => {
  const authContext = useContext(AuthContext);

  if (!authContext) return null;
  const { user, tenant, logout } = authContext;
  const isPlatformOwner = user?.role === UserRole.PLATFORM_OWNER;

  return (
    <header className="bg-gray-900/50 backdrop-blur-md shadow-md z-20 border-b border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-4">
            {!isPlatformOwner && tenant && (
                <div className="flex items-center gap-2">
                    <span className="text-gray-500 text-sm">Agencia:</span>
                    <span className="brand-text font-bold uppercase tracking-tight">{tenant.name}</span>
                </div>
            )}
            {isPlatformOwner && (
                <div className="flex items-center gap-2">
                    <span className="bg-blue-600/20 text-blue-400 px-2 py-0.5 rounded text-[10px] font-bold">MODO SUPER ADMIN</span>
                </div>
            )}
          </div>
          <div className="flex items-center gap-6">
            <div className="flex flex-col items-end">
                <span className="text-white text-sm font-medium">{user?.name}</span>
                <span className="text-gray-500 text-[10px] uppercase font-bold">{user?.role.replace('_', ' ')}</span>
            </div>
            <button
              onClick={logout}
              className="px-4 py-2 brand-bg text-white rounded-lg hover:opacity-90 transition-all text-sm font-bold shadow-lg shadow-brand-primary/10"
            >
              Cerrar Sesión
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
